import { Link } from 'react-router-dom';
import banner from '../../images/login-banner.png';
import { PATHS } from '../../paths';
import styles from './index.module.css';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <p className={styles.sectionBody}>{children}</p>
    </div>
  );
}

function Support() {
  return (
    <div className={styles.page}>
      <div className={styles.brandBar}>
        <img src={banner} alt="Joyya" className={styles.brandLogo} />
      </div>
      <div className={styles.content}>
        <div className={styles.doc}>
          <h1 className={styles.docTitle}>Joyya Support</h1>
          <p className={styles.docSubtitle}>
            Need a hand with the Joyya app? Here's how to get help.
          </p>
          <hr className={styles.divider} />

          <Section title="Getting the app">
            Don't have Joyya installed yet? <Link to={PATHS.GET_THE_APP}>Follow our step-by-step guide</Link> to
            get it on Android or iPhone.
          </Section>

          <Section title="Getting access">
            Joyya is invitation-only. If you don't have an account yet, ask your community
            leader or membership officer for an invitation code, then sign up in the app with it.
          </Section>

          <Section title="Trouble signing in">
            Use "Forgot Password?" on the login screen to reset your password by email. If you're
            still stuck, or your invitation code isn't working, contact us below and we'll sort it out.
          </Section>

          <Section title="Reporting a problem">
            If something in the app looks wrong, a post needs moderating, or you've found a bug,
            email us with as much detail as you can (what you were doing, and a screenshot if
            possible) and we'll take a look.
          </Section>

          <div className={styles.contact}>
            <p className={styles.contactLabel}>Contact support</p>
            <a href="mailto:developers@joyya.com" className={styles.contactLink}>
              developers@joyya.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Support };
